import { getWebInfo } from "utils";

export const initialState = getWebInfo();
